import type { MoveAction } from "../types/actions";
import type { WarchestState } from "../types/game-state";
import {
  advanceActivePlayer,
  allHandsEmpty,
  moveCoin,
} from "../utils/zone-utils";

export function applyMove(
  state: WarchestState,
  action: MoveAction,
): WarchestState {
  const zones = moveCoin(
    state.playerZones[action.player],
    action.coinType,
    "hand",
    "discardFaceUp",
  );
  const movingCell = state.board[action.fromHex];
  if (!movingCell) return state;
  const newBoard = {
    ...state.board,
    [action.fromHex]: null,
    [action.toHex]: movingCell,
  };
  const newPlayerZones = { ...state.playerZones, [action.player]: zones };
  const nextActive = advanceActivePlayer(action.player, newPlayerZones);
  const nextPhase = allHandsEmpty(newPlayerZones)
    ? ("DRAW_COINS" as const)
    : state.phase;
  return {
    ...state,
    board: newBoard,
    playerZones: newPlayerZones,
    activePlayer: nextActive,
    phase: nextPhase,
    initiativeTransferredThisRound:
      nextPhase === "DRAW_COINS" ? false : state.initiativeTransferredThisRound,
    turn: nextPhase === "DRAW_COINS" ? state.turn + 1 : state.turn,
  };
}
